import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import "./assets/css/responsive.css";
import "../src/PIP_Screen.css"
import './index.css';
import './Pages/CallingVideo.css';
import './Pages/PaymentSuccessful.css';
import './Pages/ContentManager/CmButtonControl.css';
import './Pages/ContentManager/MainCM.css';
import './Pages/ContentManager/NewsLiveStreamN.css';
import './Pages/ContentManager/SchedulePart/SchedulePopup.css';
import './Pages/Landing/CustomCursor.css';
import './Pages/Landing/DashboardFlow.css';
import './Pages/Landing/landing.css';
import './Pages/Landing/landingvideo.css';
import './Pages/Landing/RemoteControl.css';
import './Pages/MainAdmin/mainadmin.css';
import './Pages/OneToOne/NewStyle.css';
import './Pages/OneToOne/videocall.css';
import './Pages/restaurant/menu.css';
import './Pages/restaurant/restaurantstyle.css';
import './components/AlertPopup.css';
import './components/CallPopups.css';
import './components/ChatPopup.css';
import './components/Payment/PaymentForm.css';
import './components/Payment/PaymentMethodSelector.css';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import States from './Pages/states';
import { ToastContainer } from 'react-toastify';
import { RedirectProvider } from './Context/RedirectContext';
import { GlobalDataProvider } from './Context/GlobalDataContext';
import React, { useEffect, useRef, useState } from 'react';
import AppRoutes from './Routes/Route';
import { CardStateProvider } from './utils/CardStateContext';
import ErrorBoundary from './components/ErrorBoundary';
import StageAccessGate from './components/StageAccessGate';
import AuthSessionListener from './components/AuthSessionListener';
import CmPipWindow from './Pages/ContentManager/CmPipWindow';
import GlobalScreenMirror from './Pages/Landing/GlobalScreenMirror';
import {
    readCniSelection,
    saveCniSelection,
    markCniWatching,
    wasCniWatching,
} from './utils/cniViewerSession';

// Landing pages already render their own dedicated QR/remote overlay
// (RemoteControlOverlay) — skip the global screen-mirror there to avoid
// two competing QR codes/rooms on the same page. The CM broadcast studio
// pages have their own dense, fixed bottom control bar (incl. Logout) that
// the floating mirror button would sit on top of, so they're excluded too.
const SCREEN_MIRROR_EXCLUDED_PATHS = [
    '/', '/home', '/cmLanding',
    '/cm', '/GlobalAdmin', '/MasterAdmin', '/SuperAdmin',
    '/news-livestream', '/broadcaster',
];

// The live-news ("CNI") viewer route — leaving this page would otherwise
// destroy its Zego session outright (Viewer.js tears down on unmount).
const CNI_PATHS = ['/News', '/cm-cni'];

// The CM broadcast studio (fullscreen "Impact" card or its own standalone
// route) already shows its own live camera feed full-size — the floating
// CmPipWindow (a small preview of the CNI viewer, with its own resize
// handle) landing on top of it here was pure redundant clutter, not a
// second stream the user actually needed to see.
const CNI_PIP_HIDDEN_PATHS = ['/ott-hyperspace', '/news-livestream'];

function App() {
function parseJwt(token) {
  try {
    // JWT payloads are base64URL-encoded. Bare atob() throws on the URL-safe
    // characters `-` and `_`, which made valid tokens look un-parseable and
    // logged real users out on every mount. Normalise to standard base64 and
    // pad before decoding.
    const part = token.split('.')[1];
    if (!part) return null;
    let base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) base64 += '=';
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

useEffect(() => {
  const token = localStorage.getItem("token");

  if (token) {
    const decoded = parseJwt(token);

    if (!decoded || decoded.exp * 1000 < Date.now()) {
      // Watching a live broadcast needs no login, so an expired token must not
      // cost the viewer their place: carry the CNI state/LGA selection across
      // the wipe and, if they're already on the live-news page, clear the stale
      // token in place instead of bouncing them out to the state/LGA list.
      const onCniPage = CNI_PATHS.includes(window.location.pathname);
      const cniSelection = readCniSelection();
      const cniWatching = wasCniWatching();

      localStorage.clear();
      sessionStorage.clear();

      saveCniSelection(cniSelection.state, cniSelection.lga);
      if (cniWatching) markCniWatching(true);
      if (onCniPage && cniSelection.state && cniSelection.lga) {
        // Re-seed what the viewer page and its location badge read.
        sessionStorage.setItem("stateId", cniSelection.state);
        sessionStorage.setItem("provinceId", cniSelection.lga);
      }

      if (onCniPage) return;

      // Redirect to "/" — it exists on both the full and CM builds. "/home" is
      // only a client-side redirect in the CM build, so a full-page load there
      // would hit a server 404.
      window.location.replace("/");
    }
  }
}, []);

    return (
        <Router>
            <MainContent />
        </Router>
    );
}

function MainContent() {
    const [, setSelectedState] = useState(null);
    const location = useLocation();
    const [redirectPath, setRedirectPath] = useState(null);

    const handleStateSelect = (stateName, navigate) => {
        setSelectedState(stateName);
        if (redirectPath) {
            navigate(redirectPath);
            setRedirectPath(null);
        }
    };

    // Show a floating PiP of the CNI live viewer when the user navigates
    // away from it, instead of it going blank. Hides again once they're
    // back on the CNI page itself (avoid a duplicate stream).
    const [cniPipVisible, setCniPipVisible] = useState(false);
    const wasOnCniRef = useRef(false);
    const lastCniPathRef = useRef(CNI_PATHS[0]);

    useEffect(() => {
        const onCniNow = CNI_PATHS.includes(location.pathname);
        if (onCniNow) {
            lastCniPathRef.current = location.pathname;
            setCniPipVisible(false);
        } else if (wasOnCniRef.current) {
            setCniPipVisible(true);
        }
        wasOnCniRef.current = onCniNow;
    }, [location.pathname]);

    return (
        <GlobalDataProvider>
            <RedirectProvider>
                  <CardStateProvider>
                <div>
                    <AuthSessionListener />
                    {/* Toastify defaults to z-index 9999, which sits BEHIND the
                        payment modals (10001/10002) — their errors were being
                        hidden. Keep the container above every overlay. */}
                    <ToastContainer
                        position="top-right"
                        autoClose={3000}
                        style={{ zIndex: 2147483647 }}
                    />
                    <div className='container-fluid p-0'>
                        <States onStateSelect={handleStateSelect} redirectPath={redirectPath} />
                        <div>
                            <ErrorBoundary>
                                <StageAccessGate>
                                    <AppRoutes />
                                </StageAccessGate>
                            </ErrorBoundary>
                        </div>
                    </div>
                    {cniPipVisible && !CNI_PIP_HIDDEN_PATHS.includes(location.pathname) && (
                        <CmPipWindow
                            isOpen={cniPipVisible}
                            onClose={() => setCniPipVisible(false)}
                            content={{ title: 'Live News' }}
                            path={lastCniPathRef.current}
                        />
                    )}
                    {!SCREEN_MIRROR_EXCLUDED_PATHS.includes(location.pathname) && <GlobalScreenMirror />}
                    {/* <Footer /> */}
                </div>
                </CardStateProvider>
        </RedirectProvider>
        </GlobalDataProvider>
    );
}



export default App;